import { useState } from "react";
import { ArrowRightIcon } from "../../components/Icons";

function CTAButton({ label, variant = "outline", arrow = false, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="relative rounded-full p-[1px] w-fit"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Base border — fades out on hover */}
      <div className={`absolute inset-0 rounded-full transition-opacity duration-400 ${
        variant === "filled"
          ? "bg-black dark:bg-white"
          : "bg-border-light dark:bg-border-dark"
      } ${hovered ? "opacity-0" : "opacity-100"}`} />

      {/* Gradient border — fades in on hover */}
      <div className={`absolute inset-0 rounded-full bg-gradient-to-r from-brand-blue via-brand-purple to-brand-pink transition-opacity duration-400 ${
        hovered ? "opacity-100" : "opacity-0"
      }`} />

      <button
        onClick={onClick}
        className={`relative z-10 px-6 py-2.5 rounded-full font-sans text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
          variant === "filled"
            ? hovered
              ? "bg-white dark:bg-black text-black dark:text-white"
              : "bg-black dark:bg-white text-white dark:text-black"
            : variant === "muted"
            ? "bg-white dark:bg-black text-text-muted-light dark:text-text-muted-dark"
            : "bg-white dark:bg-black text-black dark:text-white"
        }`}
      >
        <span className="flex items-center gap-1.5">
          {label}
          {arrow && (
            <span className={`inline-flex transition-transform duration-300 ${hovered ? "translate-x-1" : "translate-x-0"}`}>
              <ArrowRightIcon size={14} />
            </span>
          )}
        </span>
      </button>
    </div>
  );
}

export default CTAButton;
